import { SVGProps, Ref, forwardRef } from 'react';

export const EyeCrossedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2.5C3.5 2.5.333 6.625 0 8c.154.636.915 1.861 2.134 2.994L.586 13.057l1.12.84L3.22 11.88a9.3 9.3 0 0 0 2.044 1.105L4.72 15.16l1.358.34.533-2.132a7.4 7.4 0 0 0 2.774 0l.533 2.132 1.358-.34-.543-2.175a9.3 9.3 0 0 0 2.044-1.104l1.513 2.016 1.12-.84-1.546-2.061C15.084 9.863 15.846 8.636 16 8c-.333-1.375-3.5-5.5-8-5.5"
                fill="currentColor"
            />
        </g>
    </svg>
));
EyeCrossedFilledSize16Glyph.displayName = 'EyeCrossedFilledSize16Glyph';
